<template>
  <section class="container">
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker title="请选择停车场" value-key='parkName' show-toolbar :columns="columns" @confirm="onConfirm"
        @cancel="showPicker = false" />
    </van-popup>

    <van-tabs color='#4794ED' v-model="active">
      <van-tab title="月卡续费">
        <div class="header"
          :style="{backgroundImage:'url(' + require('@/assets/payment-related/payment1564@2x.png') + ')'}">
          <div class="header__info">
            <span class="header__info__title">{{
          $enumObject.providerConfig[config.projectName].provider.providerName
        }}</span>
            <span class="header__info__content">-{{
            $enumObject.providerConfig[config.projectName].provider.propagandaInfo
          }}-</span>
          </div>
        </div>
        <h3 class="prompt_tips">月租车</h3>
        <van-field size='large' input-align='center' :is-linkr='true' readonly clickable :value="park?park.parkName:''"
          placeholder="请点击选择停车场" @click="showPicker = true" />
        <div class="page page-index">
          <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
        </div>

        <div class="btn_box">
          <van-button @click="submit" size="large" class="blue-btn">
            查询月卡
          </van-button>
        </div>
        <div v-if="imgBtn.jumpURL" style="margin:10px 0 10px;padding:0 5px 0;background-color:#fff;">
          <a :href="imgBtn?imgBtn.jumpURL:''">
            <van-image width="100%" height="auto" :key="index" :src="imgBtn?imgBtn.imageURL:''" />
          </a>
        </div>
        <div v-if="jntcImg.jumpURL" style="margin:10px 0 10px;padding:0 5px 0;background-color:#fff;">
          <a :href="jntcImg?jntcImg.jumpURL:''">
            <van-image width="100%" height="auto" :key="index" :src="jntcImg?jntcImg.imageURL:''" />
          </a>
        </div>

      </van-tab>
      <van-tab title="月卡申请">
        <div class="bind__header">
          <div class="bind__header__info">
            <!-- <span class="bind__header__info__title">月卡申请</span> -->
            <!-- <span class="bind__header__info__content">点击查看预约记录</span>
            <van-button type="primary" color="#4897FA" to="reserve-parking" size="small" style="padding: 5px;"
              @click="GoJump()">预约记录
            </van-button> -->
          </div>
          <div class="bind__header__2dpic" :style="{
          backgroundImage:
            'url(' + require('@/assets/payment-related/BD_carbanner.png') + ')'
        }"></div>
        </div>
        <div class="bind-modal">
          <div class="title">
            请输入相关信息提交申请
          </div>
          <div class="page page-index">
            <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
          </div>
          <van-cell-group>
            <van-field v-model="value" label="车主姓名" placeholder="请输入您的姓名" input-align='right' />
            <van-field v-model="value1" label="手机号码" placeholder="请输入手机号码" input-align='right' />
            <van-field v-model="value2" label="身份证号" placeholder="请输入身份证号码" input-align='right' />
            <van-field v-model="value3" label="驾驶证号" placeholder="请输入驾驶证号码" input-align='right' />
            <van-cell title="车场名称" value="龙江里停车场" />
            <!-- <van-cell @click="show=true" title="停车时间" :value="FromData.time.substring(0,10)" /> -->
            <!-- <van-cell title="预约押金" value="5￥" /> -->
            <!-- <van-cell title="">
              <template #right-icon>
                <van-checkbox shape="square" v-model="checked">预约协议</van-checkbox>
              </template>
            </van-cell> -->
          </van-cell-group>

          <div class="btn_box">
            <van-button @click="createPlateNumber" size="large" class="blue-btn">提交申请</van-button>
          </div>
        </div>
      </van-tab>

    </van-tabs>

  </section>
</template>

<script>
import { Field, Toast, Picker, Popup, Tab, Tabs, Dialog, DatetimePicker, checkbox } from 'vant'
import { queryPark, queryMonthlyFee } from '@/api/card'
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: {
    keyboard,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    [DatetimePicker.name]: DatetimePicker,
    [checkbox.name]: checkbox,
    [Picker.name]: Picker,  },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
      columns: [],
      park: null,
      active: 1,
      value: '',
      value1: '',
      value2: '',
      value3: '',
      showPicker: false,
      FromData: {
        time: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        name: '',
        plateNumber: [],
        carNumber: '',
        park: ''
      },
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn'])
  },
  mounted () {
    this.handleRefresh()
  },
  methods: {
    createPlateNumber () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      if (this.value && this.value1 && this.value2 && this.value3) {
        this.$toast.success('提交申请成功。')

      } else {
        this.$toast.success('请输入相关信息！')
      }
    },
    onConfirm (res) {
      this.park = res
      this.showPicker = false
    },
    handleRefresh () {
      let params = {
        vehicleType: 1 //停车场类型
      }
      queryPark(params).then(res => {
        this.columns = res.body
      }).catch(err => {
        this.$toast(err)
      })
    },
    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      if (!this.park) {
        _this.$toast('请选择停车场！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        parkid: this.park.parkId,
        isSign: 1,
      }
      queryMonthlyFee(params).then(res => {
        if (res.status == 1001) {
          // this.$store.commit('transaction/SET_BILL_PARAMS', params)
          this.$router.push({
            name: 'card-pay',
            query: res.body
          })
        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.$toast(err)
      })

    }
  },

}
</script>

<style lang="scss" scoped>
.container {
  .bind__header {
    display: flex;
    flex-direction: colunm;
    flex-wrap: wrap;
    padding: 25px;
    margin-top: 10px;
    background: linear-gradient(
      -52deg,
      rgba(26, 73, 251, 1),
      rgba(71, 140, 245, 1)
    );

    &__info {
      width: 50%;
      color: rgba(255, 255, 255, 1);

      span {
        display: block;
      }

      &__title {
        font-size: 17px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        line-height: 26px;
      }

      &__content {
        font-size: 14px;
        line-height: 38px;
      }
    }

    &__2dpic {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 50%;
      height: 20vh;
      min-height: 140px;
    }
  }

  .bind-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    max-width: 90%;
    height: 65vh;
    min-height: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(37, 44, 63, 0.1);
    border-radius: 5px;
    margin: 30vh auto 0;

    .title {
      text-align: center;
      font-size: 17px;
      line-height: 1.5;
      line-height: 1.5;
      padding: 25px 0 10px;
    }

    .btn_box {
      padding: 0 15px;
    }

    .page {
      padding: 10px;
    }
  }
  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>